import { alpha, darken, lighten, useMediaQuery } from "@mui/material";

const useStyles = (theme, elementSelected, layer, collapse, editMode) => ({
  textLayer: {
    backgroundColor: alpha(theme.palette.background.default, 0.7),
    display: "flex",
    borderRadius: 2,
    fontSize: "10px",
    fontWeight: 400,
    height: "35px",
    padding: 1,
    paddingLeft: 3,
    ml: -2,
    mb: 1.2,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: 1,
    color: theme.palette.layers?.[layer],
    borderRight: `3px solid ${theme.palette.layers?.[layer]}`,
    transition: "color 0s linear .5s, border-right 0s linear .5s", // 👈 animação suave na cor
  },
  button: {
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    bottom:
      useMediaQuery(theme.breakpoints.down("mdl")) || elementSelected
        ? "40px"
        : "15px",
    left: "15px",
    zIndex: 1,
    width: "70px",
    height: "70px",
    minWidth: "0px",

    backgroundColor: theme.palette.background.paperSelectedMaps,
    border: "1px solid " + theme.palette.color.appBarBorder,
    "&:hover": {
      backgroundColor: theme.palette.background.default,
    },
  },
  container: {
    position: "absolute",
    left: "0px",
    bottom: editMode ? { xs: "80px", lg: "40px" } : "40px",
    ml: { xs: "10px", lg: "20px" },
    display: "flex",
    flexDirection: "row",
    alignItems: "end",
    zIndex: 1,
    transition: "left 0.3s ease",
  },
  colorLayer: (layer) => ({
    color: theme.palette.layers?.[layer],
  }),
  textButton: {
    fontSize: "12px",
    fontWeight: 600,
  },
});
export default useStyles;
